import React from 'react';
import Copy from 'copy-to-clipboard';
import './style.less';

const _UID = document.getElementById('hidden-uid-value') ? document.getElementById('hidden-uid-value').value : '';

class ErrorTips extends React.PureComponent {
	constructor(props, context) {
		super(props, context);
		this.closeClick = this.closeClick.bind(this);
		this.refreshPage = this.refreshPage.bind(this);
		this.clickToCopy = this.clickToCopy.bind(this);
	}

	componentDidMount() {
	}

	closeClick(e) {
		let options = this.props;
		if (e.target.className.match(/(rule-box)|(close)/)) {
			options && options.close_cb && options && options.close_cb();
		}
	}

	refreshPage() {
		window.location.reload();
	}

	clickToCopy() {
		let options = this.props;
		let text = _UID + '|' + (options.copy_text || options.error_code);

		Copy(text, {
			debug: false,
			message: '复制完成！'
		});


		window.Toast.notice({
			content: '复制成功',
			onClose: () => {

			}
		});
	}

	render() {
		let options = this.props;
		return <React.Fragment>
			{
				options && options.show ?
					<div id='component-api-error-tips' className={'rule-box style-'+(options.theme || '1')} onClick={this.closeClick}>
						{
							options.error_type === 'time_out' ? <div className='box'>
								<div className='content'>网络超时</div>
								<div className='handle-btn' onClick={this.refreshPage}>点击刷新重试</div>
								<i className='close'/>
							</div> : ''
						}
						{
							options.error_type === 'need_login' ? <div className='box'>
								<div className='content'>登录失败</div>
								<div className='handle-btn' onClick={this.refreshPage}>点击刷新重试</div>
								<i className='close'/>
							</div> : ''
						}
						{
							options.error_type === 'auth_fail' ? <div className='box'>
								<div className='content'>Auth Fail</div>
								<div className='handle-btn' onClick={this.refreshPage}>点击刷新重试</div>
								<i className='close'/>
							</div> : ''
						}
						{
							options.error_type === 'server_error' ? <div className='box server_error'>
								<div className='title'>
									发生了问题，点击“复制信息”
									<br/>按钮粘贴发送给老师
								</div>
								<div className='content'>
									{
										options.error_message ? options.error_message : (options.error_code || '接口请求异常')
									}
								</div>
								<div className='handle-btn' onClick={this.clickToCopy}>复制信息</div>
								<i className='close'/>
							</div> : ''
						}
					</div> : ''
			}
		</React.Fragment>;
	}
}


export default ErrorTips;



// WEBPACK FOOTER //
// ./src/components/public/apiErrorTips/tpl.js